import { LatLng, type PathOptions } from 'leaflet';
import { noddiColors } from 'noddi-ui-common';

/** Booking car-pin must stay within this distance of the service address. */
export const MAP_PIN_RESTRICTION_RADIUS_M = 150;

export const MAP_PIN_RESTRICTION_PATH_OPTIONS: PathOptions = {
  color: noddiColors.noddiPurple,
  weight: 3,
  dashArray: '8 8',
  fillOpacity: 0.08
};

export const clampLatLngToRadius = (point: LatLng, center: LatLng, radiusMeters: number): LatLng => {
  const distance = point.distanceTo(center);
  if (distance <= radiusMeters) {
    return point;
  }
  const ratio = radiusMeters / distance;
  return new LatLng(center.lat + (point.lat - center.lat) * ratio, center.lng + (point.lng - center.lng) * ratio);
};

export const getInitialRestrictedCoords = ({
  initialLatitude,
  initialLongitude,
  addressLatitude,
  addressLongitude,
  radiusMeters = MAP_PIN_RESTRICTION_RADIUS_M
}: {
  initialLatitude?: number;
  initialLongitude?: number;
  addressLatitude?: number;
  addressLongitude?: number;
  radiusMeters?: number;
}): { lat: number; lng: number } | null => {
  if (initialLatitude === undefined || initialLongitude === undefined) {
    return null;
  }

  if (addressLatitude === undefined || addressLongitude === undefined) {
    return { lat: initialLatitude, lng: initialLongitude };
  }

  const clamped = clampLatLngToRadius(
    new LatLng(initialLatitude, initialLongitude),
    new LatLng(addressLatitude, addressLongitude),
    radiusMeters
  );
  return { lat: clamped.lat, lng: clamped.lng };
};
